import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/PaymentSuccess.css';

function PaymentUpdateSuccess() {
  const navigate = useNavigate();
  const { user_id } = useParams();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(`/settings/${user_id}`);
    }, 10000);
    return () => clearTimeout(timer);
  }, [navigate, user_id]);

  return (
    <div className="payment-success-container">
      <div className="logo">BestDay2Marry</div>
      <div className="payment-message">
        <h1>Payment Process Updated Successfully!</h1>
        <p>You will be redirected shortly to your account settings.</p>
      </div>
      <div className="spinner"></div>
    </div>
  );
}

export default PaymentUpdateSuccess;